// Stripe and database money fields use whole cents, not floating-point dollars.
export const dollarsToCents = (dollars: number): number => Math.round(dollars * 100);

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const formatCurrency = (value: number) => usdFormatter.format(value / 100);
